import { File } from "./File";

export class Image extends File {}
